/**
 * Auth0 Callback Handler for Web Platform
 *
 * Handles the OAuth callback from Auth0 on web.
 * Shows a loading state during the brief transition.
 */

import { Platform } from "react-native";
import * as WebBrowser from "expo-web-browser";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { Loading } from "@src/components/Loading";

if (Platform.OS === "web") {
  WebBrowser.maybeCompleteAuthSession();
}

export default function AuthCallbackScreen() {
  return (
    <View flex={1} bg="background" justifyContent="center" alignItems="center" gap="lg">
      <Loading />
      <Text textStyle="md/regular" color="textMuted">
        Completing authentication...
      </Text>
    </View>
  );
}
